import { render, staticRenderFns } from "./СMWillCome.vue?vue&type=template&id=37b0df34&lang=pug"
import script from "./СMWillCome.vue?vue&type=script&lang=js"
export * from "./СMWillCome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports